import { createBaseFields } from './baseSchema.js';

/**
 * System Settings collection schema (Singleton documents)
 */
export const systemSettingsSchema = {
    ...createBaseFields('', ''),
    // Defaults for onboarding settings
    professionalInviteRequired: { _value: true },
    employerInviteRequired: { _value: true },
};

/**
 * Create onboarding settings document
 */
export const createOnboardingSettingsDocument = ({
    professionalInviteRequired = true,
    employerInviteRequired = true
} = {}) => {
    // We don't really use baseFields for this singleton in validatable way, 
    // but keeping consistency if needed.
    // Using fixed ID 'onboarding' usually.

    return {
        professionalInviteRequired: Boolean(professionalInviteRequired),
        employerInviteRequired: Boolean(employerInviteRequired),
        updatedAt: new Date()
    };
};
